import type { SongRequest } from '../services/requests';

export function shouldRouteToCoApprover(
  coApprovalEnabled: boolean,
  coApprovalStatus: SongRequest['coApprovalStatus']
): boolean {
  return coApprovalEnabled && coApprovalStatus !== 'rejected' && coApprovalStatus !== 'approved';
}

export function isWaitingOnCoApprover(
  coApprovalEnabled: boolean,
  coApprovalStatus: SongRequest['coApprovalStatus']
): boolean {
  return coApprovalEnabled && coApprovalStatus === 'pending';
}

// Mirrors the server's isWaitingOnCoApprover, so the co-approver's page and the alert email agree on when the list is empty
export function isOnCoApproverList(request: Pick<SongRequest, 'status' | 'coApprovalStatus'>): boolean {
  return request.status === 'pending' && request.coApprovalStatus === 'pending';
}

// A song left waiting when co-approval was switched off must not keep its stale 'pending' mark once the DJ approves it
export function staleCoApprovalFields(
  routeToCoApprover: boolean,
  coApprovalStatus: SongRequest['coApprovalStatus']
): { coApprovalStatus: null } | Record<string, never> {
  return !routeToCoApprover && coApprovalStatus === 'pending' ? { coApprovalStatus: null } : {};
}
